export default "<p>\n  main works!\n</p>\n"